(function () {
  var ACTIVE_CLASS = 'is-active';
  var MOBILE_MQ = '(max-width: 749px)';

  function isMobileView() {
    try {
      return window.matchMedia && window.matchMedia(MOBILE_MQ).matches;
    } catch (e) {
      return false;
    }
  }

  function setOpenState(wrapper, isOpen) {
    if (!wrapper) return;
    wrapper.classList.toggle('is-open', !!isOpen);

    var toggle = wrapper.querySelector('[data-qcm-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    var nav = wrapper.querySelector('.quick-click-menu__nav');
    var hideNav = isMobileView() && !isOpen;
    if (nav) {
      nav.setAttribute('aria-hidden', hideNav ? 'true' : 'false');
      if (hideNav) nav.setAttribute('inert', '');
      else nav.removeAttribute('inert');
    }

    Array.prototype.slice.call(wrapper.querySelectorAll('.quick-click-menu__link')).forEach(function (link) {
      link.tabIndex = hideNav ? -1 : 0;
    });
  }

  // Mobile-only collapsible behavior.
  function initMobileCollapse(wrapper) {
    if (!wrapper) return;
    if (wrapper.dataset.qcmCollapseInit === '1') return;

    var toggle = wrapper.querySelector('[data-qcm-toggle]');
    if (!toggle) return;

    function sync() {
      if (isMobileView()) {
        toggle.tabIndex = 0;
        toggle.removeAttribute('aria-disabled');
        // Default to collapsed on mobile unless the user has opened it.
        setOpenState(wrapper, wrapper.dataset.qcmOpen === '1');
      } else {
        // Not collapsible above mobile.
        toggle.tabIndex = -1;
        toggle.setAttribute('aria-disabled', 'true');
        setOpenState(wrapper, true);
      }
    }

    toggle.addEventListener('click', function (ev) {
      if (!isMobileView()) return;
      ev.preventDefault();
      var next = !wrapper.classList.contains('is-open');
      wrapper.dataset.qcmOpen = next ? '1' : '0';
      setOpenState(wrapper, next);
    });

    // Keep state correct across device rotation / resizing.
    try {
      var mq = window.matchMedia(MOBILE_MQ);
      if (mq && typeof mq.addEventListener === 'function') mq.addEventListener('change', sync);
      else if (mq && typeof mq.addListener === 'function') mq.addListener(sync);
    } catch (e) {
      window.addEventListener('resize', sync, { passive: true });
    }

    wrapper.dataset.qcmCollapseInit = '1';
    sync();
  }

  // Makes all buttons equal width (largest button sets the width).
  function applyEqualButtonWidth(wrapper) {
    if (!wrapper) return;
    var listEl = wrapper.querySelector('[data-qcm-list]');
    if (!listEl) return;

    // Reset to intrinsic sizing before measuring.
    try {
      wrapper.style.setProperty('--qcm-button-width', 'auto');
    } catch (e) {}

    var links = listEl.querySelectorAll('.quick-click-menu__link');
    if (!links || !links.length) return;

    var max = 0;
    Array.prototype.slice.call(links).forEach(function (a) {
      if (!a) return;
      var w = 0;
      try {
        w = Math.ceil(a.getBoundingClientRect().width);
      } catch (e) {
        try {
          w = Math.ceil(a.offsetWidth || 0);
        } catch (e2) {
          w = 0;
        }
      }
      if (w > max) max = w;
    });

    if (max > 0) {
      var available = 0;
      try {
        available = Math.floor(listEl.getBoundingClientRect().width || 0);
      } catch (e) {
        available = 0;
      }
      if (!available) {
        try {
          available = Math.floor(wrapper.getBoundingClientRect().width || 0);
        } catch (e2) {
          available = 0;
        }
      }
      if (available > 0) max = Math.min(max, available);

      try {
        wrapper.style.setProperty('--qcm-button-width', max + 'px');
      } catch (e) {}
    }
  }

  // Re-run equal width calculations on resize (single global listener)
  var _qcmResizeTimer = null;
  function scheduleWidthRecalc() {
    if (_qcmResizeTimer) window.clearTimeout(_qcmResizeTimer);
    _qcmResizeTimer = window.setTimeout(function () {
      Array.prototype.slice
        .call(document.querySelectorAll('[data-qcm]'))
        .forEach(function (wrapper) {
          applyEqualButtonWidth(wrapper);
        });
    }, 120);
  }

  if (!window._qcmResizeBound) {
    window.addEventListener('resize', scheduleWidthRecalc, { passive: true });
    window._qcmResizeBound = true;
  }

  function prefersReducedMotion() {
    try {
      return (
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    } catch (e) {
      return false;
    }
  }

  function slugify(text) {
    try {
      return (text || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
    } catch (e) {
      return (text || '')
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
    }
  }

  function smoothScrollTo(el) {
    if (!el) return;
    try {
      var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
      el.scrollIntoView({ behavior: behavior, block: 'start' });
    } catch (e) {
      var top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo(0, top);
    }
  }

  function getArticleContentContainer() {
    return (
      document.querySelector('[data-article-content]') ||
      document.querySelector('.article-template__content') ||
      document.querySelector('.article-template__content.rte') ||
      document.querySelector('article.article-template .rte') ||
      document.querySelector('article .rte')
    );
  }

  function disconnectObserver(node) {
    if (node && node._qcmObserver && typeof node._qcmObserver.disconnect === 'function') {
      try {
        node._qcmObserver.disconnect();
      } catch (e) {}
    }
    node._qcmObserver = null;
  }

  function buildMenu(listEl) {
    if (!listEl) return;

    var wrapper = listEl.closest('[data-qcm]');
    if (wrapper) disconnectObserver(wrapper);

    var container = getArticleContentContainer();
    if (!container) {
      if (wrapper) wrapper.remove();
      return;
    }

    listEl.innerHTML = '';

    var headings = Array.prototype.slice
      .call(container.querySelectorAll('h2'))
      .filter(function (h) {
        return !h.hasAttribute('data-toc') || h.getAttribute('data-toc') !== 'false';
      });

    if (!headings.length) {
      if (wrapper) wrapper.remove();
      return;
    }

    var frag = document.createDocumentFragment();
    headings.forEach(function (h, i) {
      if (!h.id) {
        var base = slugify(h.textContent || 'section-' + (i + 1));
        var id = base || 'section-' + (i + 1);
        var n = 2;
        while (document.getElementById(id)) {
          id = (base || 'section') + '-' + n++;
        }
        h.id = id;
      }

      try {
        h.style.scrollMarginTop = '6rem';
      } catch (e) {}

      var li = document.createElement('li');
      var a = document.createElement('a');
      var index = document.createElement('span');
      var label = document.createElement('span');
      var itemNumber = i + 1;
      var itemText = (h.textContent || '').trim() || 'Section ' + itemNumber;

      a.className = 'quick-click-menu__link';
      a.href = '#' + h.id;
      a.setAttribute('data-id', h.id);

      index.className = 'quick-click-menu__index';
      index.setAttribute('aria-hidden', 'true');
      index.textContent = itemNumber < 10 ? '0' + itemNumber : String(itemNumber);

      label.className = 'quick-click-menu__label';
      label.textContent = itemText;

      a.appendChild(index);
      a.appendChild(label);
      li.appendChild(a);
      frag.appendChild(li);
    });

    listEl.appendChild(frag);

    var countEl = wrapper && wrapper.querySelector('[data-qcm-count]');
    if (countEl) {
      countEl.textContent = headings.length + (headings.length === 1 ? ' section' : ' sections');
    }

    // Mobile collapsible (no effect above mobile)
    if (wrapper) initMobileCollapse(wrapper);

    // Equal-width buttons: allow one frame for layout before measuring
    if (wrapper) {
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(function () {
          applyEqualButtonWidth(wrapper);
        });
      } else {
        applyEqualButtonWidth(wrapper);
      }
    }

    if (listEl.dataset.qcmBound !== '1') {
      listEl.addEventListener('click', function (ev) {
        var a = ev.target.closest('a');
        if (!a || !listEl.contains(a)) return;
        var id = a.getAttribute('data-id');
        var target = id && document.getElementById(id);
        if (!target) return;
        ev.preventDefault();
        smoothScrollTo(target);
      });
      listEl.dataset.qcmBound = '1';
    }

    var linkMap = {};
    Array.prototype.slice.call(listEl.querySelectorAll('a')).forEach(function (a) {
      linkMap[a.getAttribute('data-id')] = a;
    });

    var lastActiveId = null;
    function setActive(id) {
      if (!id || !linkMap[id]) return;
      if (lastActiveId && linkMap[lastActiveId]) {
        linkMap[lastActiveId].classList.remove(ACTIVE_CLASS);
        linkMap[lastActiveId].removeAttribute('aria-current');
      }
      linkMap[id].classList.add(ACTIVE_CLASS);
      linkMap[id].setAttribute('aria-current', 'true');
      lastActiveId = id;
    }

    try {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            if (entry.target && entry.target.id) setActive(entry.target.id);
          });
        },
        { root: null, rootMargin: '0% 0% -70% 0%', threshold: [0, 1] }
      );

      headings.forEach(function (h) {
        io.observe(h);
      });

      if (wrapper) wrapper._qcmObserver = io;
    } catch (e) {
      function updateFromHash() {
        var id = (location.hash || '').replace('#', '');
        if (id) setActive(id);
      }
      window.addEventListener('hashchange', updateFromHash);
      updateFromHash();
    }

    var initialId = (location.hash || '').replace('#', '');
    if (initialId && document.getElementById(initialId)) setActive(initialId);
    else if (headings[0] && headings[0].id) setActive(headings[0].id);
  }

  function buildAll() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-qcm-list]'))
      .forEach(function (listEl) {
        buildMenu(listEl);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildAll);
  } else {
    buildAll();
  }

  document.addEventListener('shopify:section:load', buildAll);
  document.addEventListener('shopify:section:select', buildAll);
  document.addEventListener('shopify:section:deselect', buildAll);
})();
